module.exports = require("./gsw-LI.d.ts");